const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import { Alert } from '@mui/material';

class LimitMessage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <Alert className="wpvc_max_limit" elevation={6} variant="filled" onClose={this.props.handleLimitClose} severity="error">
                {t('you_have_reach_limit')}
            </Alert>
        )
    }
}

export default connect()(withTranslation("translations")(LimitMessage));
